import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import { showToast } from "../../Common/Messages";

const EditorHome = (props) => {    
    const LoginStates = useSelector(state => state.login);
    const [noticeList, setNoticeList] =useState([]);
    const [templateList, setTemplateList] =useState([]);
    const [openSetting, setOpenSetting] =useState(false);
    useEffect(()=>{
        getEditorNotice();
        getTemplate();
    },[]);
    const getDocBoxInfo = (docBox) => {
        return null;
    }
    const moveToDocBox = (docBox) => {
        props.setCurrentDocBox(docBox);
    }
    const getDocbox = () => {
        if (props.docBoxList.length > 0) {
            return (
                props.docBoxList.filter(x => x.docBoxType === "Documents").map(x => {
                    return (
                        <div className="docbox">
                            <Link onClick={() => moveToDocBox(x)}>
                                <div className="docbox-top">
                                    <div className="docbox-title">
                                        <i className="icoKdc40 parcel"></i>
                                        <h2 className="docbox-name">{x.docBoxName}</h2>
                                    </div>
                                    <i className="icoKdc40 arrow"></i>
                                </div>
                            </Link>
                            <div className="docbox-btm">
                                {getDocBoxInfo(x.docBoxPath)}
                            </div>
                        </div>
                    );
                })
            );
        } else { return null; }
    }
    const getEditorNotice = async () => {
        const body = {
            userId: '',
            userName: '',
            workingTag: 'postList',
            pageNo: 1,
            groupNo: 3,
            postInfo: {
                contentType: '',
                postSeq: 0,
                attachSeq: 0,
                commentSeq: 0,
                postData: {
                    title: '',
                    content: '',
                    attachment: [],
                    comment: ''
                }
            }
        };
        const response = await fetch('api/Document/NewsManage', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        });
        const result = await response.json();
        const json = JSON.parse(result.postData);        
        setNoticeList(json.postDatas.slice(0,3))
    }
    const getTemplate = async () => {
        const body = {
            folderName: "template",
            devUserId: ""
        }
        const response = await fetch("api/Edit/GetBoxDocumentList/Template", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        });
        const result = await response.json();
        if (response.status === 200 && result.data) {
            setTemplateList(
                result.data.table
            )
        }
    }

    return (
        <div className="editorhome">
            <section className="editorhome-cnts">
                <div className="title-wrap">
                    <h1 className='page-title'>문서함을 선택하세요.</h1>
                    {LoginStates.admin?.includes('Director') &&
                        <button className="setting" onClick={() => setOpenSetting(true)}>
                            <i className="icoKdc20 setting-s"></i>관리
                        </button>
                    }
                </div>
                {openSetting &&
                    <EditorHomeSetting setOpenSetting={setOpenSetting} docBoxList={props.docBoxList.filter(x => x.docBoxType === "Documents")} setDocBoxList={props.setDocBoxList} />
                }
                <div className="editorhome-top">
                    {getDocbox()}
                </div>
                <div className="editorhome-btm">
                    <div className="editor-noti">
                        <div className="editor-noti-top">
                            <Link to='/EditCenter/News'>
                                <h1 className='page-title'>에디터 공지사항</h1>
                                <i className="icoKdc20 seemore-m"></i>
                            </Link>
                        </div>
                        <ul className="editor-noti-cnts">
                            {
                                noticeList.map(x=>{return (
                                    <li className="editor-noti-list">
                                        <p className="noti-title">{x.postdata.posttitle}</p>
                                        <span className="noti-date">{x.postdata.timestamp}</span>
                                    </li>
                                )})
                            }
                        </ul>
                    </div>
                    <div className="template">
                        <div className="editor-noti-top">
                            <Link onClick={() => moveToDocBox(props.docBoxList.find(x => x.docBoxPath === "template"))}>
                                <h1 className='page-title'>템플릿</h1>
                                <i className="icoKdc20 seemore-m"></i>
                            </Link>
                        </div>
                        <ul className="template-cnts">
                            {templateList.slice(0,4).map((x, index) => { 
                                return (
                                    <li className="template-list">
                                        <Link onClick={() => moveToDocBox(props.docBoxList.find(x => x.docBoxPath === "template"))} state={{doc: x}}>
                                            <i className="icoKdc40 template-i"></i>
                                            <p className="template-title">{x.title}</p>
                                        </Link>
                                    </li>
                                )})
                            }
                        </ul>
                    </div>
                </div>
            </section>
        </div>
    )
};
export default EditorHome;

const EditorHomeSetting = (props) => {
    const LoginStates = useSelector(state => state.login);

    const [docBoxList, setDocBoxList] = useState([]);
    const [newDocBoxInfo, setNewDocBoxInfo] = useState({name:'', path:''});
    const [isAddingFolder, setIsAddingFolder] = useState(false);
    const [editingIndex, setEditingIndex] = useState(null);
    const [activeMenu, setActiveMenu] = useState(-1);
    const [position, setPosition] = useState({top: 0, left: 0})
    const moreRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (moreRef.current && !moreRef.current.contains(e.target)){
                setActiveMenu(-1);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, [])

    useEffect(() => {
        setDocBoxList(props.docBoxList);
    }, [props.docBoxList]);

    const clickMore = (e, index) => {
        e.preventDefault();
        e.stopPropagation();

        if (activeMenu === index) {
            setActiveMenu(-1);
        } else {
            let element = e.target;
            let totalTopOffset = 0;
            let totalLeftOffset = 0;
            let isRelative = false;
            while (element) {
                // 부모 요소의 margin, padding 추가
                const { position, marginTop, paddingTop, marginLeft, paddingLeft } = getComputedSpacing(element);
                if(position === "absolute" || position === "fixed") break;
                if(position === "relative") isRelative = true;
                totalTopOffset += marginTop + paddingTop;
                if(isRelative) {
                    totalLeftOffset += marginLeft + paddingLeft;
                }

                // 이전 형제 요소들 검사
                if (element.parentElement) {
                    let sibling = element.previousElementSibling;
                    while (sibling) {
                        const { marginTop, marginBottom } = getComputedSpacing(sibling);
                        totalTopOffset += marginTop + marginBottom;
                        sibling = sibling.previousElementSibling;
                    }
                }

                element = element.parentElement; // 부모 요소로 이동
            }
            const rect = e.target.getBoundingClientRect();
            setPosition({top: rect.bottom - totalTopOffset, left: rect.left - totalLeftOffset});
            setActiveMenu(index);
        }
    }
    
    const getComputedSpacing = (element) => {
        const computedStyle = window.getComputedStyle(element);
        return {
            styleElement: element,
            position: computedStyle.position,
            marginTop: parseFloat(computedStyle.marginTop),
            marginBottom: parseFloat(computedStyle.marginBottom),
            paddingTop: parseFloat(computedStyle.paddingTop),
            paddingBottom: parseFloat(computedStyle.paddingBottom),
            marginLeft: parseFloat(computedStyle.marginLeft),
            marginRight: parseFloat(computedStyle.marginRight),
            paddingLeft: parseFloat(computedStyle.paddingLeft),
            paddingRight: parseFloat(computedStyle.paddingRight),
        };
    }

    const handleAddFolderClick = () => {
        setNewDocBoxInfo({name: '', path: ''});
        setEditingIndex(null);
        setIsAddingFolder(true);
    };

    const handleAddFolderComplete = () => {
        if (newDocBoxInfo.name.trim() && newDocBoxInfo.path.trim()) {
            if(checkExist(editingIndex))
                if (editingIndex !== null) {
                    saveDocBox('U', docBoxList[editingIndex]);
                    setEditingIndex(null);
                } else {
                    saveDocBox('A');
                }
        } else {
            if (!newDocBoxInfo.name.trim())
                showToast("warning", "문서함명을 입력해주세요.");
            else if (!newDocBoxInfo.path.trim())
                showToast("warning", "키워드를 입력해주세요.");
        }
    };

    const checkExist = (editingIndex = -1) => {
        if (docBoxList.find((box, index) => index !== editingIndex && box.docBoxName === newDocBoxInfo.name.trim())) {
            showToast("warning", "이미 존재하는 문서함명입니다.");
            return false;
        }
        if (docBoxList.find((box, index) => index !== editingIndex && box.docBoxPath === newDocBoxInfo.path.trim())) {
            showToast("warning", "이미 존재하는 키워드입니다.");
            return false;
        }
        return true;
    }

    const handleInputChange = (e) => {
        let value = e.target.value;
        if(e.target.name === "path") {
            value = value.replace(/[^A-Za-z]/ig, '').toLowerCase();
        }
        setNewDocBoxInfo(prev => { return {...prev, [e.target.name]: value}});
    };

    const handleAddFolderCancel = () => {
        setNewDocBoxInfo({name:'', path:''});
        setEditingIndex(null);
        setIsAddingFolder(false);
    };

    const handleEditFolderClick = (index) => {
        setIsAddingFolder(false);
        setEditingIndex(index);
        setNewDocBoxInfo({name: docBoxList[index].docBoxName, path: docBoxList[index].docBoxPath});
    };

    const handleDeleteFolder = (index) => {
        const userResponse = window.confirm("문서함을 삭제하시겠습니까?");
        if (userResponse) {
            saveDocBox('D', docBoxList[index]);
        }
    };

    const saveDocBox = (workingTag, docBox) => {
        if (LoginStates.userId === '' || newDocBoxInfo.name === docBox?.docBoxName) return;
        const body = {
            workingTag: workingTag,
            devUserId: LoginStates.userId,
            docBoxSeq: workingTag === 'A' ? 0 : docBox.docBoxSeq,
            docBoxName: newDocBoxInfo.name,
            docBoxPath: workingTag === 'A' ? newDocBoxInfo.path : docBox.docBoxPath
        };
        fetch('api/Edit/SaveDocumentsBox', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        }).then((response) => response.json())
            .then(resultData => {
                if (resultData.message === 'Success') {
                    props.setDocBoxList(resultData.data.table.length > 0 ? resultData.data.table : docBoxList);
                    showToast('success', '저장 완료');
                    setNewDocBoxInfo({name: '', path: ''});
                    setIsAddingFolder(false);
                }
                else {
                    showToast('danger', '저장 실패');
                }
            });
    };
    
    return (
        <div className="msg-popup-wrap dim">
            <div className="msg-popup">
                <div className='modal'>
                    <div className='modal-top'>
                        <h3 className='modal-title'>문서함 전체 관리</h3>
                        <button className="btn-close" onClick={() => props.setOpenSetting(false)}>
                            <i className="icoKdc32 close"></i>
                        </button>
                    </div>
                    <div className='modal-cnts'>
                        <button className='btn-addfolder' onClick={handleAddFolderClick}>
                            <i className='icoKdc20 add-g'></i>추가
                        </button>
                        <div className='folder-list-wrap'>
                            <ul className="folder-list" style={{height: "300px", overflowY: "auto"}}>
                                {docBoxList.map((x, index) => {
                                    return editingIndex === index ? 
                                    ( 
                                        <li className="folder-list-add">
                                            <i className='icoKdc24 parcel-24'></i>
                                            <div className="add-folder-name">
                                                <input
                                                    name="name"
                                                    placeholder="새 문서함 이름 입력"
                                                    value={newDocBoxInfo.name}
                                                    onChange={handleInputChange}
                                                    autoFocus
                                                />
                                                <div className="add-folder-btns-wrap">
                                                    <button className='btn-cancel' onClick={handleAddFolderCancel}>취소</button>
                                                    <button className='btn-add' onClick={handleAddFolderComplete}>완료</button>
                                                </div>
                                            </div>
                                        </li>
                                    )
                                    : 
                                    (
                                        <li className={`folder-list-each ${activeMenu === index ? 'selected' : ''}`}>
                                            <div className="folder-name-wrap">
                                                <i className="icoKdc24 parcel-24"></i>
                                                <span className="folder-name">{x.docBoxName}</span>
                                            </div>
                                            <button onClick={(e) => clickMore(e, index)}>
                                                <i className='icoKdc24 kebab-24'></i>
                                                {activeMenu === index &&
                                                    <div ref={moreRef} className="context-menu" style={{top: position.top+'px', left: position.left+'px'}}>
                                                        <ul>
                                                            <li onClick={() => handleEditFolderClick(index)}><a className='default'>문서함명 변경</a></li>
                                                            <li onClick={() => handleDeleteFolder(index)}><a className="nega">삭제</a></li>
                                                        </ul>
                                                    </div>
                                                }
                                            </button>
                                        </li>
                                    )
                                })}
                                {isAddingFolder && (
                                    <li className="folder-list-add">
                                        <i className='icoKdc24 parcel-24'></i>
                                        <div className="add-folder-name">
                                            <input
                                                name="name"
                                                placeholder="새 문서함 이름 입력"
                                                value={newDocBoxInfo.name}
                                                onChange={handleInputChange}
                                                style={{fontSize:"14px"}}
                                                autoFocus
                                            />
                                            <input
                                                name="path"
                                                placeholder="영문 키워드 입력(저장 후 수정 불가)"
                                                value={newDocBoxInfo.path}
                                                onChange={handleInputChange}
                                                style={{fontSize:"14px"}}
                                            />
                                            <div className="add-folder-btns-wrap">
                                                <button className='btn-cancel' onClick={handleAddFolderCancel}>취소</button>
                                                <button className='btn-add' onClick={handleAddFolderComplete}>완료</button>
                                            </div>
                                        </div>
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                    <div className="mail-list-btm">
                        <button className='btn-share' onClick={() => props.setOpenSetting(false)}>확인</button>
                    </div>
                </div>
            </div>
        </div>
    )
}